import { } from 'vue';
import { useNotif } from '@orion.ui/orion';
import BaseSetupService from '@/setup/BaseSetupService';
import UserAgencyRatingApiAgency from '@/api/UserAgencyRatingApiAgency';
import useBusService from '@/services/BusService';

type Props = SetupProps<typeof TempWorkerRatingSetupService.props>
type Emits = {(e: 'rate-updated'): void};

export default class TempWorkerRatingSetupService extends BaseSetupService<Props> {
	static readonly props = {
		rating: {
			type: Number,
			default: undefined,
		},
		authorRating: {
			type: Object,
			default: undefined,
		},
		numberOfRating: {
			type: Number,
			default: 0,
		},
		targetRatingId: {
			type: Number,
			default: undefined,
		},
	};

	private emits: Emits;

	get authorRate (): number { return this.props.authorRating?.rating ?? 0; }
	set authorRate (val) { this.updateRateAsync(val); }


	constructor (props: Props, emits: Emits) {
		super(props);
		this.emits = emits;
	}


	async updateRateAsync (payload: number) {
		if (!this.props.targetRatingId) return;

		const rate = {
			userId: this.props.targetRatingId,
			rating: payload,
		};

		if (this.self.isAgency()) {
			if (this.authorRate) {
				const { data } = await UserAgencyRatingApiAgency.update(rate);
				useBusService().emit(`${this.props.targetRatingId}-list-item:ranking-update`, data);
				useBusService().emit(`${this.props.targetRatingId}-details:ranking-update`, data);
			} else {
				const { data } = await UserAgencyRatingApiAgency.add(rate);
				useBusService().emit(`${this.props.targetRatingId}-list-item:ranking-update`, data);
				useBusService().emit(`${this.props.targetRatingId}-details:ranking-update`, data);
			}
		}

		useNotif.success('Note sauvegardée');
		this.emits('rate-updated');
	}
}
